import s from '../style.module.css'
import SearchResultsCardShimmer from '../../search-result-card/shimmer'
import clsx from 'clsx'
import {resultsLimit} from '../search-results-client'
import AnimateOnVisibleWrapper from '@app/components/sidebar/sidebar-tags-container/animate-visiblity/animate-visiblity-wrapper'

const SearchResultsShimmer = () => {
  return (
    <div className={clsx(s.featured_games_results)}>
      {Array.from({length: resultsLimit}).map((_, i) => (
        <AnimateOnVisibleWrapper index={i} key={i}>
          <SearchResultsCardShimmer />
        </AnimateOnVisibleWrapper>
      ))}
    </div>
  )
}

export default SearchResultsShimmer
